import { resolveLandingMedia } from "./landingMedia";
import { normalizeImagePosition } from "./segmentVisualStyle";

export function landingSectionBackgroundSx(visualStyle = {}) {
  const imageUrl = resolveLandingMedia(visualStyle?.backgroundImageUrl);
  if (!imageUrl) return {};
  const safeUrl = String(imageUrl).replace(/"/g, "%22");
  return {
    backgroundImage: `url("${safeUrl}")`,
    backgroundSize: "cover",
    backgroundPosition: normalizeImagePosition(visualStyle?.backgroundImagePosition),
    backgroundRepeat: "no-repeat",
  };
}
